import { TicketCreation } from '../containers/TicketCreation';
import { usePortalData } from '../data/usePortalData';
import { useNavigationContext } from '../hooks/useNavigationContext';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { PortalMessage } from 'portals-platform-lib';
import I18n from 'I18n';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { PortalConfirmModal } from './atoms/PortalConfirmModal';
import { useConfirmModal } from '../hooks/useConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function TicketCreationPanel() {
  var _portalData$settings$, _portalData$settings, _portalData$settings2;
  const {
    toListings
  } = useNavigationContext();
  const {
    data: portalData,
    loading: portalLoading
  } = usePortalData();
  const title = (_portalData$settings$ = portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.formHeaderText) !== null && _portalData$settings$ !== void 0 ? _portalData$settings$ : '';
  const formGuid = portalData === null || portalData === void 0 || (_portalData$settings2 = portalData.settings) === null || _portalData$settings2 === void 0 ? void 0 : _portalData$settings2.formGuid;
  const {
    isOpen: isConfirmingClose,
    openConfirmModal,
    confirmModalProps
  } = useConfirmModal({
    onConfirm: toListings
  });
  const triggerElementRef = useRef(null);
  useLayoutEffect(() => {
    triggerElementRef.current = document.activeElement;
  }, []);
  useEffect(() => {
    const triggerElement = triggerElementRef.current;
    return () => {
      triggerElement === null || triggerElement === void 0 || triggerElement.focus();
    };
  }, []);
  useEffect(() => {
    if (!portalLoading && (!formGuid || !portalData)) {
      toListings();
    }
  }, [portalLoading, formGuid, portalData, toListings]);
  if (!formGuid || !portalData) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ModalPanel, {
      width: 560,
      paddingInline: "600",
      onEsc: openConfirmModal
      // dialogStyles spreads onto <Dialog role="dialog"> — used to inject aria-labelledby
      // until ModalPanel/ModalDialog natively supports the prop.
      ,
      dialogStyles: {
        'aria-labelledby': 'ticket-creation-dialog-heading'
      },
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        id: "ticket-creation-dialog-heading",
        typography: "heading-500",
        color: "text-core-default",
        paddingBlock: "600",
        paddingInline: "600",
        children: /*#__PURE__*/_jsx(PortalMessage, {
          messageKey: "SUPPORT_SPACE_FORM_HEADER_TEXT",
          fallback: title
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: openConfirmModal,
        "aria-label": I18n.text('customer-portal-app.ticketListings.ticketCreationCloseButton'),
        color: "icon-core-default"
      }), /*#__PURE__*/_jsx(PanelSection, {
        padding: "0",
        flush: true,
        children: /*#__PURE__*/_jsx(TicketCreation, {
          onSuccess: toListings,
          formGuid: formGuid,
          portalData: portalData
        })
      })]
    }), isConfirmingClose && /*#__PURE__*/_jsx(PortalConfirmModal, Object.assign({
      message: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmMessage'),
      description: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmDescription'),
      confirmLabel: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmButton'),
      rejectLabel: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardCancelButton'),
      size: "auto"
    }, confirmModalProps))]
  });
}